(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  function initialize(section) {
    if (instances.has(section)) return;
    let frame;
    const items = [...section.querySelectorAll('.gallery__item')];
    function layout() {
      frame = null;
      if (!section.isConnected) return;
      const headings = [];
      items.forEach(item => {
        const heading = item.querySelector('.gallery__item-caption h3');
        const text = heading?.querySelector('.gallery__heading-text');
        if (!text || !text.getBoundingClientRect().width) return;
        heading.style.removeProperty('font-size');
        heading.style.removeProperty('min-height');
        const maximum = parseFloat(getComputedStyle(heading).fontSize);
        const fits = () => text.getBoundingClientRect().height <= parseFloat(getComputedStyle(heading).lineHeight) * 2 + 0.5;
        if (!fits()) {
          let low = 1;
          let high = maximum;
          for (let step = 0; step < 12; step++) {
            const size = (low + high) / 2;
            heading.style.setProperty('font-size', size + 'px', 'important');
            if (fits()) low = size;
            else high = size;
          }
          heading.style.setProperty('font-size', low + 'px', 'important');
        }
        if (!item.classList.contains('floating__text')) headings.push({ item, heading });
      });
      const rows = [];
      headings.forEach(entry => {
        const top = entry.item.getBoundingClientRect().top;
        let row = rows.find(row => Math.abs(row.top - top) < 2);
        if (!row) rows.push(row = { top, entries: [] });
        row.entries.push(entry);
      });
      rows.forEach(row => {
        if (row.entries.length < 2) return;
        const bottom = Math.max(...row.entries.map(({ heading }) => heading.getBoundingClientRect().bottom));
        row.entries.forEach(({ heading }) => {
          heading.style.minHeight = (bottom - heading.getBoundingClientRect().top) + 'px';
        });
      });
    }
    function schedule() {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(layout);
    }
    const widths = new WeakMap();
    const observer = new ResizeObserver(entries => {
      if (entries.some(entry => {
        const width = entry.contentRect.width;
        const previous = widths.get(entry.target);
        widths.set(entry.target, width);
        return width !== previous;
      })) schedule();
    });
    observer.observe(section);
    items.forEach(item => {
      observer.observe(item);
      const image = item.querySelector('.gallery__item-image, .onboard');
      if (image) observer.observe(image);
    });
    section.addEventListener('load', schedule, true);
    window.addEventListener('resize', schedule);
    document.fonts?.ready.then(schedule);
    document.fonts?.addEventListener('loadingdone', schedule);
    instances.set(section, () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
      section.removeEventListener('load', schedule, true);
      window.removeEventListener('resize', schedule);
      document.fonts?.removeEventListener('loadingdone', schedule);
      instances.delete(section);
    });
    schedule();
  }
  function scan(root) {
    if (root.matches?.('[data-gallery-fit]')) initialize(root);
    root.querySelectorAll('[data-gallery-fit]').forEach(initialize);
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-gallery-fit]').forEach(section => instances.get(section)?.());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h9-editorial-text"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('h9-sticky-text')) {
  customElements.define('h9-sticky-text', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.pin = this.querySelector('.h9-sticky-text__pin');
      if (!this.pin) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        this.frame = null;
        const height = this.pin.offsetHeight;
        const top = Math.max(0, (window.innerHeight - height) / 2);
        this.style.setProperty('--h9-st-top', top + 'px');
        const rect = this.getBoundingClientRect();
        this.classList.toggle('is-held', !reduced.matches && rect.top <= top && rect.bottom > top);
      };
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
      const measure = () => { this.style.setProperty('--h9-st-h', this.pin.offsetHeight + 'px'); schedule(); };
      const options = { signal: this.controller.signal, passive: true };
      window.addEventListener('scroll', schedule, options);
      window.addEventListener('resize', measure, options);
      reduced.addEventListener('change', schedule, options);
      if ('ResizeObserver' in window) { this.observer = new ResizeObserver(measure); this.observer.observe(this.pin); }
      measure();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.classList.remove('is-held');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
